import MiotStatBase from "../base/spm.base.web";
import SessionStorage from "../utils/sessionStorage";
import { addParam } from "../utils/utils"
class MiotStat extends MiotStatBase {
  random: number;
  constructor(config,sendStat,) {
    // 初始化传入的方法，如果不存在，则使用web方法或者空
    super(config,sendStat);
    this.random = 0;
  }

  /**
   * 获取该页面的spm 或者 带有spmref和scm的url
   * @param {Object} param
   */
  getSpm(param:Spm, eventName?:string) {
    let random = Math.floor(Math.random() * Math.pow(10, 8));
    if (eventName === "touch") {
      this.random = random;
    } else if (!eventName && this.random !== 0) {
        random = this.random;
    }
    if (typeof param === "object" && (param.b || param.url)) {
      if(param.spmref) {
        let url = addParam(param.url, 'spmref', param.spmref)
        const scm = param.scm || this.scm || "";
        if (url.indexOf("scm=") == -1 && scm && scm.length) {
          // 如果这个链接没有scm并且这个页面有scm 就拼接上scm参数
          // url = url + "&scm=" + scm;
          url = addParam(url, 'scm', scm)
        }
        return url
      }else{
      // try {
        const spmref = `${this.config.spmA}.${param.b}.${param.c || 0}.${param.d ||
          0}.${random}`;
        const scm = this.scm || "";
        if (!param.b) {
          // 没有传递b位，表示该url不用拼接任何参数
          return param.url;
        } else if (param.url) {
          // 需要一个拼接上spmref和scm的url链接
          let url = addParam(param.url, 'spmref', decodeURIComponent(spmref))
          // param.url +
          // (param.url.indexOf("?") > -1 ? "&" : "?") +
          // "spmref=" +
          // spmref;
          if (url.indexOf("scm=") == -1 && scm && scm.length) {
            // 如果这个链接没有scm并且这个页面有scm 就拼接上scm参数
            // url = url + "&scm=" + scm;
            url = addParam(url, 'scm', scm)
          }
          return url;
        } else {
          // 仅仅是为了生成一个 spmref
          return spmref;
        }
      }
      // } catch (error) {
      //     return ''
      // }
    }else{
      return ''
    }
    
  }
  getRef() {
    let sstr = [];
    let actionStack = [];
    try {
      let actionStackTemp = SessionStorage.getItem("routeStack");
      if (actionStack) {
        actionStack = JSON.parse(actionStackTemp);
      }
    } catch (e) {}

    for (let i = 0, l = actionStack.length; i < l; i++) {
      let item = actionStack[i];
      sstr.push(this.buildRef(item));
      if (i < l - 1) {
        sstr.push("/");
      }
    }
    return sstr;
  }
}

export default MiotStat;
